const initSlider = (identifier, config, breakpoint) => {
    let slider = null;
    if (breakpoint) {
      const runOnMatch = (media) => {
        if (media.matches && !slider) {
          config.init = false;
          slider = new Swiper(identifier, config);
          slider.init();
        }
        if (!media.matches && slider) {
          slider.destroy();
          slider = null;
        }
      };
      const media = window.matchMedia(
        `only screen and (${breakpoint >= 0 ? "min" : "max"}-width: ${
          breakpoint >= 0 ? breakpoint : breakpoint * -1
        }px)`
      );
      runOnMatch(media);
      window.addEventListener("resize", () => {
        runOnMatch(media);
      });
      media.addEventListener("change", runOnMatch);
    } else {
      slider = new Swiper(identifier, config);
    }
  };

document.addEventListener('DOMContentLoaded', () => {
//For Featured brands
    initSlider(".is-brands", {
    loop: true,
    slidesPerView: 'auto', 
    spaceBetween: 0
    });
});

document.addEventListener('DOMContentLoaded', () => {
//For Featured brands
    initSlider(".is-featured", {
    loop: true,
    navigation: {
        prevEl: ".slider-arrow.is-bottom-previous.is-featured",
        nextEl: ".slider-arrow.is-bottom-next.is-featured"
    },
    pagination: {
      el: ".slider_pagination_wrapper.is-featured",
      bulletActiveClass: "is-active",
      bulletClass: "slider_dots",
      clickable: true
    },
      breakpoints: {
        0: {
          slidesPerView: 1,
        },
        768: {
          slidesPerView: 'auto',
          spaceBetween: 24
        },
        992: {
          slidesPerView: 'auto',
          spaceBetween: 24
        }
    	}
    });

    
});

document.addEventListener('DOMContentLoaded', () => {
//For Testimonial Cards
    initSlider(".is-testimonial", {
    loop: true,
		 autoplay: {
   			delay: 5000,
        pauseOnMouseEnter: true,
        speed: 1600,
		},
    pagination: {
      el: ".slider_pagination_wrapper.is-testimonials",
      bulletActiveClass: "is-active",
      bulletClass: "slider_dots",
      clickable: true
    },
    navigation: {
        prevEl: ".slider-arrow.is-centre-previous.is-testimonial",
        nextEl: ".slider-arrow.is-centre-next.is-testimonial"
    },
		breakpoints: {
        0: {
          slidesPerView: "auto",
            slidesPerGroup: 1, 
          spaceBetween: 24
        },
        768: {
          slidesPerView: 2,
            slidesPerGroup: 1, 
          spaceBetween: 24
        },
        992: {
          slidesPerView: 2,
          slidesPerGroup: 1, 
          spaceBetween: 24
        }
    	}
    }); 
});

document.addEventListener('DOMContentLoaded', () => {
//For Top Products
    initSlider(".is-top-products", {
    loop: true,
    slidesPerView: 'auto',
    spaceBetween: 24,
    navigation: {
        prevEl: ".slider-arrow.is-bottom-previous.is-top-products",
        nextEl: ".slider-arrow.is-bottom-next.is-top-products"
    },
    pagination: {
      el: ".slider_pagination_wrapper.is-top-products",
      bulletActiveClass: "is-active",
      bulletClass: "slider_dots",
      clickable: true
    }
    });
});

document.addEventListener('DOMContentLoaded', () => {
//For Product Categories
    initSlider(".is-product-categories", {
    loop: true,
    slidesPerView: 'auto',
    spaceBetween: 24,
    navigation: {
        prevEl: ".slider-arrow.is-bottom-previous.is-product-categories",
        nextEl: ".slider-arrow.is-bottom-next.is-product-categories"
    },
    pagination: {
      el: ".slider_pagination_wrapper.is-product-categories",
      bulletActiveClass: "is-active",
      bulletClass: "slider_dots",
      clickable: true
    }
    });
});

let mm = gsap.matchMedia();
mm.add("(min-width: 992px)", () => {
gsap.from(".home_brand_grid-item",{
		scrollTrigger: {
    trigger: ".section_home_brand",
    },
		opacity: 0,
		ease: "power1.out",
    y: -200,
    duration: 1,
    stagger: 0.25
  });
});

mm.add("(min-width: 992px)", () => {
	gsap.from(".values_card_item", {
		scrollTrigger: {
    trigger: ".about_values_section"
    },
    x: 200,
    opacity: 0,
    stagger: 2,
    ease: "power3.out",
    duration: 1
	});
  gsap.from(".values_image_background_wrapper", {
		scrollTrigger: {
    trigger: ".about_values_section"
    },
    x: -100,
    opacity: 0,
    stagger: 2,
    ease: "power3.out",
    duration: 1
	});


    	gsap.from(".brand_grid-item",{
      scrollTrigger: {
      trigger: ".brand_grid-item",
      },
      opacity: 0,
      ease: "power1.out",
      x: 100,
      duration: 1,
      stagger: 0.25
    });

    	let headings = gsap.utils.toArray(".interaction_gsap_slide-left");
	headings.forEach(heading => {
  	gsap.from(heading, { 
    	scrollTrigger: {
      trigger: heading,
      start: "top 80%",
    },
     x: 200,
		opacity: 0,
    ease: "power1.out",
    duration: 0.5,
  })
});

});


gsap.from(".swiper-slide.is-featured",{
		scrollTrigger: {
    trigger: ".section_featured-brands",
		start: "top 60%"
    },
		opacity: 0,
		ease: "power1.out",
    x: 200,
    duration: 1,
    stagger: 0.25
  });
gsap.from(".swiper-slide.is-product",{
		scrollTrigger: {
    trigger: ".section_product-category",
		start: "top 60%"
    },
		opacity: 0,
		ease: "power1.out",
    x: 200,
    duration: 1,
    stagger: 0.25
  });
gsap.from(".swiper-slide.is-top-products",{
		scrollTrigger: {
    trigger: ".section_component_top-products",
		start: "top 60%"
    },
		opacity: 0,
		ease: "power1.out",
    x: 200,
    duration: 1,
    stagger: 0.25
  });

document.addEventListener('DOMContentLoaded', () => {
//For Featured brands
    initSlider(".is-home-banner", {
    speed: 500,
  	spaceBetween: 100,
		autoplay: {
		delay: 5000,
 },
	effect: 'fade',
  fadeEffect: {
    crossFade: true
  },
  loop: true
    });
});


  // Function to rotate tabs
  function initializeTabRotator() {
    // Find all tab containers with the ms-code-rotate-tabs attribute
    const tabContainers = document.querySelectorAll('[ms-code-rotate-tabs]');
    tabContainers.forEach(container => {
      const interval = parseInt(container.getAttribute('ms-code-rotate-tabs'), 10);
      const tabLinks = container.querySelectorAll('.w-tab-link');
      const tabContent = container.closest('.w-tabs').querySelector('.w-tab-content');
      const tabPanes = tabContent.querySelectorAll('.w-tab-pane');
      let currentIndex = Array.from(tabLinks).findIndex(link => link.classList.contains('w--current'));
      let rotationTimer;
      // ANIMATION CONFIGURATION
      // Modify these values to adjust the animation behavior
      const FADE_OUT_DURATION = 300; // Duration for fading out the current tab (in milliseconds)
      const FADE_IN_DURATION = 100;  // Duration for fading in the new tab (in milliseconds)
      const EASING_FUNCTION = 'ease'; // Choose from: 'linear', 'ease', 'ease-in', 'ease-out', 'ease-in-out'
      // or use a cubic-bezier function like 'cubic-bezier(0.1, 0.7, 1.0, 0.1)'
      // Additional easing options (uncomment to use):
      // const EASING_FUNCTION = 'ease-in-quad';
      // const EASING_FUNCTION = 'ease-out-quad';
      // const EASING_FUNCTION = 'ease-in-out-quad';
      // const EASING_FUNCTION = 'ease-in-cubic';
      // const EASING_FUNCTION = 'ease-out-cubic';
      // const EASING_FUNCTION = 'ease-in-out-cubic';
      // const EASING_FUNCTION = 'ease-in-quart';
      // const EASING_FUNCTION = 'ease-out-quart';
      // const EASING_FUNCTION = 'ease-in-out-quart';
      // const EASING_FUNCTION = 'ease-in-quint';
      // const EASING_FUNCTION = 'ease-out-quint';
      // const EASING_FUNCTION = 'ease-in-out-quint';
      // const EASING_FUNCTION = 'ease-in-sine';
      // const EASING_FUNCTION = 'ease-out-sine';
      // const EASING_FUNCTION = 'ease-in-out-sine';
      // const EASING_FUNCTION = 'ease-in-expo';
      // const EASING_FUNCTION = 'ease-out-expo';
      // const EASING_FUNCTION = 'ease-in-out-expo';
      // const EASING_FUNCTION = 'ease-in-circ';
      // const EASING_FUNCTION = 'ease-out-circ';
      // const EASING_FUNCTION = 'ease-in-out-circ';
      // const EASING_FUNCTION = 'ease-in-back';
      // const EASING_FUNCTION = 'ease-out-back';
      // const EASING_FUNCTION = 'ease-in-out-back';
      // END OF ANIMATION CONFIGURATION
      function switchToTab(index) {
        // Fade out current tab
        tabPanes[currentIndex].style.transition = `opacity ${FADE_OUT_DURATION}ms ${EASING_FUNCTION}`;
        tabPanes[currentIndex].style.opacity = '0';
        setTimeout(() => {
          // Remove active classes and update ARIA attributes for current tab and pane
          tabLinks[currentIndex].classList.remove('w--current');
          tabLinks[currentIndex].setAttribute('aria-selected', 'false');
          tabLinks[currentIndex].setAttribute('tabindex', '-1');
          tabPanes[currentIndex].classList.remove('w--tab-active');
          // Update current index
          currentIndex = index;
          // Add active classes and update ARIA attributes for new current tab and pane
          tabLinks[currentIndex].classList.add('w--current');
          tabLinks[currentIndex].setAttribute('aria-selected', 'true');
          tabLinks[currentIndex].setAttribute('tabindex', '0');
          tabPanes[currentIndex].classList.add('w--tab-active');
          // Fade in new tab
          tabPanes[currentIndex].style.transition = `opacity ${FADE_IN_DURATION}ms ${EASING_FUNCTION}`;
          tabPanes[currentIndex].style.opacity = '1';
          // Update the data-current attribute on the parent w-tabs element
          const wTabsElement = container.closest('.w-tabs');
          if (wTabsElement) {
            wTabsElement.setAttribute('data-current', tabLinks[currentIndex].getAttribute('data-w-tab'));
          }
        }, FADE_OUT_DURATION);
      }
      function rotateToNextTab() {
        const nextIndex = (currentIndex + 1) % tabLinks.length;
        switchToTab(nextIndex);
      }
      function startRotation() {
        clearInterval(rotationTimer);
        rotationTimer = setInterval(rotateToNextTab, interval);
      }
      // Add click event listeners to tab links
      tabLinks.forEach((link, index) => {
        link.addEventListener('click', (e) => {
          e.preventDefault();
          switchToTab(index);
          startRotation(); // Restart rotation from this tab
        });
      });
      // Start the initial rotation
      startRotation();
    });
  }
  // Run the function when the DOM is fully loaded
  document.addEventListener('DOMContentLoaded', initializeTabRotator);


//NAV BAR IMAGE INVERT
  document.addEventListener('DOMContentLoaded', () => {
// Select the navbar element by class or ID (adjust if needed)
const navbar = document.querySelector('.navbar_component');

const targetSelector = '.navbar_logo .header__heading-logo-wrapper img';

// Function to apply or remove the invert filter
function updateImageFilter() {
  const computedColor = getComputedStyle(navbar).color;
  const img = document.querySelector(targetSelector);

  if (img) {
    if (computedColor === 'rgb(12, 12, 12)') {
      img.style.filter = 'invert(1)';
    } else {
      img.style.filter = '';
    }
  }
}

// Create an observer for style attribute changes
const observer = new MutationObserver(updateImageFilter);

observer.observe(navbar, {
  attributes: true,
  attributeFilter: ['style'],
});

// Run once on load
updateImageFilter();

});
 




